import { Field } from 'formik';

import {
  Box,
  Grid,
  GridItem,
  FormControl,
  FormLabel,
  Select,
  Text,
} from '@frontend/legacy-components';
import { isObject } from '@frontend/utils';

import { NumberedFormControl } from './NumberedFormControl';
import { PostOrPrefixInput } from './PostOrPrefixInput';
import type {
  FormFieldProps,
  NestingDefaultsData,
  NestingSelectOption,
} from './types';

export const COST_DIST_METHOD_SHEET_OPTIONS = [
  { label: 'Area of parts', value: 'AR' },
  {
    label: 'Number of parts',
    value: 'NU',
  },
];
export const COST_DIST_METHOD_LINEAR_OPTIONS = [
  { label: 'Length of parts', value: 'LE' },
  {
    label: 'Number of parts',
    value: 'NU',
  },
];
type PricingSettingsProps = {
  isSubmitting: boolean;
  isLinearNest?: boolean;
};
export const PricingSettings = ({
  isSubmitting,
  isLinearNest,
}: PricingSettingsProps) => {
  return (
    <Box marginBottom={2}>
      <Text fontWeight={600} marginBottom={1.5} marginTop={1.5}>
        Pricing Settings
      </Text>
      <Grid templateColumns="repeat(2, 1fr)" gap={2}>
        <GridItem>
          <Field name="costDistMethod">
            {({ field, form }: FormFieldProps<NestingDefaultsData, string>) => (
              <FormControl isReadOnly={isSubmitting}>
                <FormLabel>Price distribution method</FormLabel>
                <Select
                  isClearable={false}
                  value={
                    isObject(field.value)
                      ? field.value
                      : (isLinearNest
                          ? COST_DIST_METHOD_LINEAR_OPTIONS
                          : COST_DIST_METHOD_SHEET_OPTIONS
                        ).find((opt) => field.value === opt.value) ?? ''
                  }
                  isDisabled={isSubmitting}
                  aria-label="Price Distribution Method Dropdown"
                  onChange={(opt: NestingSelectOption) => {
                    form.setFieldValue('costDistMethod', opt.value);
                  }}
                  options={
                    isLinearNest
                      ? COST_DIST_METHOD_LINEAR_OPTIONS
                      : COST_DIST_METHOD_SHEET_OPTIONS
                  }
                />
              </FormControl>
            )}
          </Field>
        </GridItem>
        <GridItem>
          <Field name="dropThresholdPct">
            {({ field, form }: FormFieldProps<NestingDefaultsData, string>) => (
              <FormControl isReadOnly={isSubmitting}>
                <FormLabel>Drop threshold</FormLabel>
                <NumberedFormControl
                  icon2={<PostOrPrefixInput value="%" />}
                  field={field}
                  form={form}
                  min={0}
                  step={0.125}
                  ariaLabel="Drop Threshold Value"
                />
              </FormControl>
            )}
          </Field>
        </GridItem>
      </Grid>
    </Box>
  );
};
